import axios from "axios";
import store from "../redux/store/index";
import { getURL } from "../constants/index";
import { puntToSignIn } from "./APIService";

export async function getEnterpriseService() {
  const WebAPI_URL = getURL();
  const state = store.getState();
  if (state.authReducer.user == null)
    puntToSignIn();
  const token = state.authReducer.user.profile.token;
  return new Promise((resolve, reject) => {
    const config = {
      method: "GET",
      url: WebAPI_URL + "api/Entids",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + token,
      },
    };
    axios(config)
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function getEnterpriseServiceByEmail(credential) {
  const WebAPI_URL = getURL();
  const state = store.getState();
  if (state.authReducer.user == null)
    puntToSignIn();
  const token = state.authReducer.user.profile.token;
  return new Promise((resolve, reject) => {
    const config = {
      method: "GET",
      url: WebAPI_URL + "api/Entids/" + credential,
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + token,
      },
    };
    axios(config)
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

/*export async function updateInstrumentCalibration(event) {
    //debugger;
    return new Promise((resolve, reject) => {
        const config = {
            method: "POST",
            url:
                WebAPI_URL + "HygeianWebAPI/api/Instds/UpdateInstrumentCalibrationData",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                //Accept: "*!/!*",
            },
            data: JSON.stringify(updateInstrurment(event)),
        };
        axios(config)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                }
                reject(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
}*/
